import { render, staticRenderFns } from "./ShowMoneyTransfer.vue?vue&type=template&id=493389bb&"
import script from "./ShowMoneyTransfer.vue?vue&type=script&lang=js&"
export * from "./ShowMoneyTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports